import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const n = i((e, l) => /* @__PURE__ */ c.jsx(
  a,
  {
    ref: l,
    ...e,
    image: (o) => /* @__PURE__ */ c.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 17,
        fill: "none",
        viewBox: "0 0 16 17",
        ...o,
        children: /* @__PURE__ */ c.jsx(
          "path",
          {
            fill: "#1D1D44",
            fillRule: "evenodd",
            d: "M3.227 9.196q-.2-.12-.274-.42c-.03-.118-.086-.27-.152-.446v-.001c-.17-.454-.381-1.02-.27-1.426q.072-.26.266-.347c.156-.07.326-.03.42.003l.005-.034.008-.047c.05-.31.08-.63.112-.97v-.003c.057-.612.121-1.306.332-2.059C4.033 2.166 5.074.93 6.21.437 7.125.04 8.536-.289 10.054.4c1.159.526 2.064 1.738 2.422 3.242.134.562.16 1.208.184 1.779.019.442.034.823.097 1.05l.013.054.008.035c.093-.032.267-.075.425-.004q.194.087.266.347c.111.407-.1.972-.27 1.426v.001c-.066.176-.123.328-.152.447q-.074.298-.274.419a.5.5 0 0 1-.261.07l-.015-.001a12 12 0 0 0-.106.615v.004a6.42 6.42 0 0 1-2.008 3.777l-.016.013v.085c0 .49 0 1.695.215 2.282l-5.064.008c.215-.587.216-1.764.216-2.277v-.05l-.013-.008c-1.127-.975-1.909-2.333-2.14-3.769v-.004c-.001-.004-.033-.295-.1-.676a.5.5 0 0 1-.254-.07",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
n.displayName = "FrontFacingSelfieIcon";
export {
  n as FrontFacingSelfieIcon,
  n as default
};
//# sourceMappingURL=index.js.map
